// Curated tourism content for Sithonia, Halkidiki.
// All images sourced from Wikimedia Commons (Creative Commons-licensed real photos of the actual locations).
// Served via wsrv.nl image proxy (free CDN, caches & resizes Wikimedia images, bypasses rate limits).

const wiki = (path) =>
  `https://wsrv.nl/?url=https://upload.wikimedia.org/wikipedia/commons/${path}&w=900&q=80`;

const WIKI = wiki;  // backwards-compat alias

// Verified Wikimedia Commons paths (format: {hash[0]}/{hash[:2]}/{url_encoded_filename})
const IMG = {
  kavourotrypes: wiki("6/6d/Kavourotrypes_Beach%2C_Sithonia%2C_Chalkidiki.jpg"),
  karidi:        wiki("d/d1/Karidi_Beach_-_Vourvourou%2C_Sithonia%2C_Greece_-_panoramio.jpg"),
  kalogria:      wiki("d/da/Kalogria_Beach%2C_Nikiti%2C_Chalkidiki%2C_Greece.jpg"),
  lagomandra:    wiki("9/94/Lagomandra%2C_Sitonia%2C_Gr%C4%8Dka_-_panoramio_%287%29.jpg"),
  lagomandra2:   wiki("f/fb/Lagomandra%2C_Sitonia%2C_Gr%C4%8Dka_-_panoramio_%285%29.jpg"),
  lagomandra3:   wiki("c/cd/Lagomandra%2C_Sitonia%2C_Gr%C4%8Dka_-_panoramio_%2810%29.jpg"),
  nikiti_beach:  wiki("2/2b/Beach_of_Nikiti_A.jpg"),
  sarti_pano:    wiki("d/d5/Sarti%2C_Sithonia%2C_Greece_-_panoramio.jpg"),
  sarti_beach:   wiki("6/61/Beach_in_Sarti%2C_Greece.jpg"),
  klimataria:    wiki("2/29/Klimataria_beach%2C_Sithonia%2C_Greece.jpg"),
  vourvourou:    wiki("c/ca/Vourvourou_beach_sithonia_01.jpg"),
  porto_koufo:   wiki("7/7b/Porto_Koufo%2C_Sithonia%2C_Chalkidiki%2C_Greece.jpg"),
  porto_koufo2:  wiki("d/d8/Porto_Koufo%2C_IMG_0378.JPG"),
  spathies:      wiki("1/13/Spathies_beach_in_Nikiti.jpg"),
  sailboat:      wiki("1/19/Sailboat_at_Porto_Koufo.jpg"),
  sarti_beach2:  wiki("c/c1/Sarti%2C_beach.jpg"),
  nikiti_old3:   wiki("0/06/Nikiti_old_3.JPG"),
  nikiti_old2:   wiki("5/53/Nikiti_old_2.JPG"),
  nikiti_main:   wiki("4/42/Nikiti%2C_Halkidiki%2C_Greece.jpg"),
  nikiti_night:  wiki("4/43/NikitiNokturnal.jpg"),
  taverna:       wiki("6/60/Naxos_Taverna.jpg"),
  greek_meze:    wiki("2/2d/Greek_meze.jpg"),
  mezedes:       wiki("9/9b/Mezedes.jpg"),
  greek_frappe:  wiki("d/d3/Greek_frapp%C3%A9.jpg"),
  greek_coffee:  wiki("0/02/Greek_coffee_1.JPG"),
};

export const BEACHES = [
  {
    id: "kavourotrypes",
    name_el: "Καβουρότρυπες (Orange Beach)",
    name_en: "Kavourotrypes (Orange Beach)",
    desc_el:
      "Μικροί ορμίσκοι με πορτοκαλόχρωμους βράχους, κρυστάλλινα νερά και εξωτικό χαρακτήρα. Η πιο φωτογραφισμένη παραλία της Σιθωνίας.",
    desc_en:
      "Small coves carved into orange-hued rocks with turquoise water and an exotic feel. The most-photographed beach of Sithonia.",
    tags: ["snorkeling", "exotic", "couples"],
    area: "Σάρτη / Sarti",
    maps: "https://maps.google.com/?q=Kavourotrypes+Orange+Beach+Sithonia",
    img: IMG.kavourotrypes,
  },
  {
    id: "karidi",
    name_el: "Καρύδι",
    name_en: "Karidi Beach",
    desc_el:
      "Λευκή χαλικένια παραλία με ρηχά καραϊβικά νερά, αγαπημένη οικογενειακή επιλογή με beach bar και ομπρέλες.",
    desc_en:
      "White-pebble beach with shallow Caribbean-blue water — a family favourite with a relaxed beach bar.",
    tags: ["family", "beach-bar", "turquoise"],
    area: "Βουρβουρού / Vourvourou",
    maps: "https://maps.google.com/?q=Karidi+Beach+Vourvourou",
    img: IMG.karidi,
  },
  {
    id: "kalogria",
    name_el: "Καλόγρια",
    name_en: "Kalogria Beach",
    desc_el:
      "Μακριά αμμώδης παραλία περιτριγυρισμένη από πεύκα, με Blue Flag, organic beach bar και επιλογές γαλήνιες ή πιο ζωντανές.",
    desc_en:
      "Long sandy Blue-Flag beach hugged by pines — choose between the calm end and the lively beach-bar side.",
    tags: ["blue-flag", "family", "sandy"],
    area: "Νικήτη / Nikiti",
    maps: "https://maps.google.com/?q=Kalogria+Beach+Nikiti",
    img: IMG.kalogria,
  },
  {
    id: "lagomandra",
    name_el: "Λαγομάντρα",
    name_en: "Lagomandra",
    desc_el:
      "Τρεις διαδοχικοί κόλποι με βαθύ μπλε νερό, οργανωμένη παραλία με ξενοδοχείο και ένα ονειρικό sunset spot.",
    desc_en:
      "Three connecting coves with deep blue water, organised loungers, a hotel and dreamy sunset views.",
    tags: ["sunset", "organised", "couples"],
    area: "Νέος Μαρμαράς / Neos Marmaras",
    maps: "https://maps.google.com/?q=Lagomandra+Beach+Sithonia",
    img: IMG.lagomandra,
  },
  {
    id: "trani-ammouda",
    name_el: "Τρανή Αμμούδα",
    name_en: "Trani Ammouda",
    desc_el:
      "Ένας από τους πιο ήσυχους όρμους κοντά στη Νικήτη, με ρηχά νερά και πεύκα που αγγίζουν τη θάλασσα — ιδανικός για οικογένειες.",
    desc_en:
      "One of Nikiti's most peaceful coves with shallow water and pines kissing the sea — perfect for families.",
    tags: ["quiet", "family", "shallow"],
    area: "Νικήτη / Nikiti",
    maps: "https://maps.google.com/?q=Trani+Ammouda+Nikiti",
    img: IMG.nikiti_beach,
  },
  {
    id: "armenistis",
    name_el: "Αρμενιστής",
    name_en: "Armenistis Beach",
    desc_el:
      "Διάσημη για τη ζωντάνια της: το beach bar party-spot της Σιθωνίας με μουσική, cocktails και κρυστάλλινα νερά.",
    desc_en:
      "Sithonia's most famous party beach: open-air bar, music, cocktails and crystal water all day long.",
    tags: ["nightlife", "beach-bar", "young"],
    area: "Σάρτη / Sarti",
    maps: "https://maps.google.com/?q=Armenistis+Beach+Sithonia",
    img: IMG.sarti_pano,
  },
  {
    id: "sarti",
    name_el: "Σάρτη",
    name_en: "Sarti Beach",
    desc_el:
      "Πολυσύχναστη χρυσή αμμουδιά με υπέροχη θέα στον Άθω — beach bars, ταβέρνες και ηλιοβασίλεμα με το Άγιο Όρος στον ορίζοντα.",
    desc_en:
      "Long golden sand strip with a stunning view of Mount Athos — beach bars, tavernas and unforgettable sunsets.",
    tags: ["sandy", "athos-view", "lively"],
    area: "Σάρτη / Sarti",
    maps: "https://maps.google.com/?q=Sarti+Beach+Sithonia",
    img: IMG.sarti_beach,
  },
  {
    id: "klimataria",
    name_el: "Κλιματαριά",
    name_en: "Klimataria",
    desc_el:
      "Κρυμμένος όρμος-διαμάντι με πεντακάθαρα νερά και μικρό αμμοχαλικένιο μέτωπο — ιδανικός για snorkeling.",
    desc_en:
      "Hidden gem of a cove with super-clear water and a short pebbly stretch — excellent snorkeling.",
    tags: ["snorkeling", "hidden", "quiet"],
    area: "Πόρτο Κουφό / Porto Koufo",
    maps: "https://maps.google.com/?q=Klimataria+Beach+Sithonia",
    img: IMG.klimataria,
  },
  {
    id: "tigania",
    name_el: "Τηγάνια",
    name_en: "Tigania",
    desc_el:
      "Αμμώδης παραλία περιτριγυρισμένη από πεύκο. Διακρίνεται για το βαθύ τιρκουάζ της χρώμα και τα οργανωμένα beach bars.",
    desc_en:
      "Sandy beach embraced by pines, famous for deep turquoise color and welcoming beach bars.",
    tags: ["turquoise", "family", "beach-bar"],
    area: "Βουρβουρού / Vourvourou",
    maps: "https://maps.google.com/?q=Tigania+Beach+Vourvourou",
    img: IMG.vourvourou,
  },
  {
    id: "porto-koufo",
    name_el: "Πόρτο Κουφό",
    name_en: "Porto Koufo Beaches",
    desc_el:
      "Φυσικό λιμάνι (το μεγαλύτερο της Ελλάδας) με προστατευμένα νερά, ψαροταβέρνες και μαγευτικούς βραχώδεις σχηματισμούς.",
    desc_en:
      "Greece's largest natural harbour — sheltered water, fishing tavernas and dramatic cliff scenery.",
    tags: ["dramatic", "tavernas", "sheltered"],
    area: "Νότια Σιθωνία / South Sithonia",
    maps: "https://maps.google.com/?q=Porto+Koufo+Beach",
    img: IMG.porto_koufo,
  },
  {
    id: "spathies",
    name_el: "Σπαθιές",
    name_en: "Spathies",
    desc_el:
      "Μικρή απομονωμένη παραλία με λεπτή άμμο και βαθύ μπλε. Ιδανική για όσους θέλουν ησυχία και άγρια ομορφιά.",
    desc_en:
      "Small secluded beach with fine sand and deep blue water — for those after quiet and wild beauty.",
    tags: ["quiet", "secluded", "natural"],
    area: "Νικήτη / Nikiti",
    maps: "https://maps.google.com/?q=Spathies+Beach+Sithonia",
    img: IMG.spathies,
  },
  {
    id: "elia",
    name_el: "Ελιά",
    name_en: "Elia Beach",
    desc_el:
      "Λευκή αμμουδιά με κεδρόδεντρα να φτάνουν μέχρι τη θάλασσα. Διάσημη για το διάφανο νερό της και τη χαλαρή ατμόσφαιρα.",
    desc_en:
      "White sand with cedar trees reaching to the shore. Known for see-through water and a laid-back vibe.",
    tags: ["sandy", "relaxed", "natural"],
    area: "Βουρβουρού / Vourvourou",
    maps: "https://maps.google.com/?q=Elia+Beach+Vourvourou",
    img: IMG.sailboat,
  },
];

// Cafés & Taverns: specific businesses don't have free Commons photos.
// We use representative Greek café / coffee / tavern Commons photos that genuinely depict Greek coffee/food culture.
const CAFE_IMG_1 = IMG.greek_frappe;
const CAFE_IMG_2 = IMG.greek_coffee;
const TAVERN_IMG_1 = IMG.taverna;
const TAVERN_IMG_2 = IMG.greek_meze;
const TAVERN_IMG_3 = IMG.mezedes;

export const CAFES = [
  {
    id: "nikiti-blue",
    name: "Blue Restaurant Café",
    style_el: "Brunch & specialty coffee",
    style_en: "Brunch & specialty coffee",
    desc_el: "Παραλιακό café στη Νικήτη με όμορφη βεράντα, εξαιρετικό brunch και all-day κουζίνα.",
    desc_en: "Seafront café in Nikiti with a beautiful terrace, excellent brunch and all-day kitchen.",
    ideal: "families · sunset",
    area: "Νικήτη / Nikiti",
    img: CAFE_IMG_1,
  },
  {
    id: "nikiti-stoa",
    name: "Stoa Café",
    style_el: "Παραδοσιακό καφενείο",
    style_en: "Traditional kafeneio",
    desc_el: "Κρυμμένο στην παλιά Νικήτη — ελληνικός καφές, μπακλαβάς και αυθεντική ατμόσφαιρα.",
    desc_en: "Tucked in old Nikiti — Greek coffee, baklava and authentic village atmosphere.",
    ideal: "couples · culture",
    area: "Νικήτη / Nikiti",
    img: CAFE_IMG_2,
  },
  {
    id: "marmaras-bahia",
    name: "Bahia Beach Bar",
    style_el: "Beach bar & cocktails",
    style_en: "Beach bar & cocktails",
    desc_el: "Από τα πιο cool beach bar της Σιθωνίας — μουσική, sunset views και signature cocktails.",
    desc_en: "One of Sithonia's coolest beach bars — music, sunset views and signature cocktails.",
    ideal: "sunset · nightlife",
    area: "Νέος Μαρμαράς / Neos Marmaras",
    img: IMG.lagomandra2,
  },
  {
    id: "marmaras-mojito",
    name: "Mojito Bay",
    style_el: "Beach bar",
    style_en: "Beach bar",
    desc_el: "Διάσημο all-day beach bar πάνω στη Λαγομάντρα με tropical vibes και θρυλικό sunset.",
    desc_en: "Famous all-day beach bar on Lagomandra with tropical vibes and a legendary sunset.",
    ideal: "groups · sunset",
    area: "Νέος Μαρμαράς / Neos Marmaras",
    img: IMG.lagomandra3,
  },
  {
    id: "sarti-tango",
    name: "Tango Café",
    style_el: "Specialty coffee & breakfast",
    style_en: "Specialty coffee & breakfast",
    desc_el: "Φωτεινό café στη Σάρτη με θέα στον Άθω και πρωινό όλη μέρα.",
    desc_en: "Bright café in Sarti with Athos views and all-day breakfast.",
    ideal: "remote work · families",
    area: "Σάρτη / Sarti",
    img: CAFE_IMG_1,
  },
  {
    id: "sarti-koukounari",
    name: "Koukounari",
    style_el: "Beach bar restaurant",
    style_en: "Beach bar restaurant",
    desc_el: "Στην παραλία της Σάρτης — από καφέ το πρωί μέχρι cocktails με θέα στο Άγιο Όρος.",
    desc_en: "Right on Sarti beach — coffee in the morning, cocktails with Athos on the horizon.",
    ideal: "couples · all-day",
    area: "Σάρτη / Sarti",
    img: IMG.sarti_beach2,
  },
];

export const TAVERNS = [
  {
    id: "nikiti-anema",
    name: "Anemos Sea-View Tavern",
    desc_el: "Φρέσκα ψάρια, παραδοσιακά μεζεδάκια και θέα στον Τορωναίο.",
    desc_en: "Fresh fish, traditional mezedes and an open view of the Toroneos Gulf.",
    specialty_el: "Σαρδέλες σχάρας · καλαμάρι γεμιστό · χταπόδι ξιδάτο",
    specialty_en: "Grilled sardines · stuffed squid · marinated octopus",
    atmosphere: "sea-view · families",
    area: "Νικήτη / Nikiti",
    img: TAVERN_IMG_2,
  },
  {
    id: "nikiti-old",
    name: "Old Nikiti Tavern",
    desc_el: "Στα δρομάκια του παλιού χωριού — αυθεντική Μακεδονική κουζίνα σε πέτρινο σπίτι.",
    desc_en: "In the old village's stone alleys — authentic Macedonian cuisine inside a 19th-century house.",
    specialty_el: "Πρόβειο κλέφτικο · πατάτες φούρνου · χωριάτικη σαλάτα",
    specialty_en: "Lamb 'kleftiko' · oven potatoes · village salad",
    atmosphere: "traditional · couples",
    area: "Νικήτη — Παλιό Χωριό",
    img: TAVERN_IMG_1,
  },
  {
    id: "marmaras-fish",
    name: "Pefkohori Fish Tavern",
    desc_el: "Διάσημη ψαροταβέρνα στο Νέο Μαρμαρά με τα φρεσκότερα θαλασσινά της Σιθωνίας.",
    desc_en: "Renowned fish tavern in Neos Marmaras with the freshest seafood in Sithonia.",
    specialty_el: "Αστακομακαρονάδα · γαρίδες σαγανάκι · ψάρι στα κάρβουνα",
    specialty_en: "Lobster pasta · shrimp saganaki · charcoal-grilled fish",
    atmosphere: "couples · groups",
    area: "Νέος Μαρμαράς / Neos Marmaras",
    img: TAVERN_IMG_3,
  },
  {
    id: "porto-koufo-akrogiali",
    name: "Akrogiali Porto Koufo",
    desc_el: "Πάνω στη θάλασσα στο φυσικό λιμάνι — ψάρι κατευθείαν από τις βάρκες των ψαράδων.",
    desc_en: "Right by the water in the natural harbor — fish straight off the fishing boats.",
    specialty_el: "Φρέσκος μπακαλιάρος · σολωμός · μύδια αχνιστά",
    specialty_en: "Fresh cod · salmon · steamed mussels",
    atmosphere: "harbour-view · families",
    area: "Πόρτο Κουφό / Porto Koufo",
    img: IMG.porto_koufo2,
  },
  {
    id: "sarti-stratos",
    name: "Stratos Taverna",
    desc_el: "Παραδοσιακή ταβέρνα στη Σάρτη με θέα στον Άθω και ζεστή φιλοξενία.",
    desc_en: "Traditional tavern in Sarti with an Athos view and warm hospitality.",
    specialty_el: "Μουσακάς · γεμιστά · ψητό στη γάστρα",
    specialty_en: "Moussaka · stuffed peppers · clay-pot roast",
    atmosphere: "athos-view · groups",
    area: "Σάρτη / Sarti",
    img: TAVERN_IMG_1,
  },
  {
    id: "ormos-mouragio",
    name: "Mouragio Ormos Panagias",
    desc_el: "Παραλιακή ψαροταβέρνα — η ψαριά της ημέρας με ηλιοβασίλεμα και ούζο.",
    desc_en: "Seaside fish tavern — catch of the day with sunset and ouzo.",
    specialty_el: "Αχινοσαλάτα · μπαρμπούνια · ψαρόσουπα",
    specialty_en: "Sea-urchin salad · red mullet · fish soup",
    atmosphere: "sunset · couples",
    area: "Όρμος Παναγίας / Ormos Panagias",
    img: TAVERN_IMG_2,
  },
];

export const OLD_VILLAGE = {
  intro_el:
    "Το Παλιό Χωριό της Νικήτης είναι ένας τόπος που σε ταξιδεύει στον χρόνο — πέτρινα σπίτια, καλντερίμια, κρυφές αυλές με γιασεμιά και η αύρα δύο αιώνων Μακεδονικής ιστορίας.",
  intro_en:
    "Nikiti's Old Village transports you back in time — stone houses, cobblestone lanes, hidden jasmine courtyards and the aura of two centuries of Macedonian history.",
  hero_img: IMG.nikiti_old3,
  gallery: [
    IMG.nikiti_old3,
    IMG.nikiti_old2,
    IMG.nikiti_main,
    IMG.nikiti_night,
  ],
  timeline: [
    { year: "1745", el: "Πρώτη γραπτή αναφορά στο χωριό από τους μοναχούς του Αγίου Όρους.", en: "First written mention of the village by Mount Athos monks." },
    { year: "1800s", el: "Άνθιση της Νικήτης — μεταξί, σιτηρά και ναυτιλία.", en: "Nikiti flourishes from silk, grain trade and shipping." },
    { year: "1821", el: "Σημαντική συμμετοχή στην Ελληνική Επανάσταση.", en: "Significant participation in the Greek Revolution." },
    { year: "Σήμερα / Today", el: "Πολιτιστικό στολίδι της Χαλκιδικής, διατηρώντας την αρχιτεκτονική του 19ου αιώνα.", en: "Cultural gem of Halkidiki, preserving its 19th-century architecture." },
  ],
  highlights: [
    {
      key: "saint-nikitas",
      icon: "Church",
      title_el: "Ναός Αγίου Νικήτα",
      title_en: "Church of Saint Nikitas",
      desc_el: "Ο πολιούχος της κωμόπολης, χτισμένος στον 18ο αιώνα, με σπάνιες αγιογραφίες.",
      desc_en: "The village patron, built in the 18th century, featuring rare frescoes.",
    },
    {
      key: "stone-houses",
      icon: "Home",
      title_el: "Πέτρινα Αρχοντικά",
      title_en: "Stone Mansions",
      desc_el: "Δείγματα Μακεδονικής αρχιτεκτονικής με ξυλόγλυπτα μπαλκόνια και πέτρινα τόξα.",
      desc_en: "Macedonian-style architecture with carved wooden balconies and stone arches.",
    },
    {
      key: "central-square",
      icon: "TreePine",
      title_el: "Κεντρική Πλατεία",
      title_en: "Central Square",
      desc_el: "Σκιερά πλατάνια, παραδοσιακά καφενεία και η καρδιά του χωριού κάθε βράδυ.",
      desc_en: "Shady plane trees, traditional kafeneia and the village's beating heart every evening.",
    },
    {
      key: "byzantine-basilica",
      icon: "Landmark",
      title_el: "Βυζαντινή Βασιλική Αγίου Γεωργίου",
      title_en: "Byzantine Basilica of St. George",
      desc_el: "Παλαιοχριστιανικός ναός του 5ου αι., με ψηφιδωτά δάπεδα — εξαιρετικό αρχαιολογικό μνημείο.",
      desc_en: "Early-Christian basilica from the 5th c. with mosaic floors — a remarkable monument.",
    },
    {
      key: "viewpoint",
      icon: "Mountain",
      title_el: "Σημείο Θέας 'Τσούκα'",
      title_en: "'Tsouka' Viewpoint",
      desc_el: "Από εδώ απλώνεται όλος ο Τορωναίος κόλπος — το πιο μαγικό ηλιοβασίλεμα της Σιθωνίας.",
      desc_en: "The full Toroneos Gulf unfolds from here — Sithonia's most magical sunset.",
    },
    {
      key: "evening-walk",
      icon: "Footprints",
      title_el: "Βραδινός Περίπατος",
      title_en: "Evening Walk",
      desc_el: "Καλντερίμια φωτισμένα με κίτρινο, μυρωδιές από γιασεμί και τζατζίκι, ζωντανή μουσική στις μικρές πλατείες.",
      desc_en: "Cobbled lanes lit gold, scents of jasmine and grilled meat, live music in small squares.",
    },
  ],
};
